import { useTranslation } from "@shared/utils/internationalization";
import Cookies from "js-cookie";
import Link from "@ui-kit/navigation/Link/Link.web";
import CDNImage from "@ui-kit/media/CDNImage/CDNImage.web";
import type { GooglePlayStoreLinkSharedProps } from "./GooglePlayStoreLink.props";

export default function GooglePlayStoreLink(
  props: GooglePlayStoreLinkProps
): JSX.Element {
  const { t } = useTranslation("common");
  const { className, onClick, lang } = props;

  const locale = lang || Cookies.get("NEXT_LOCALE");

  return (
    <Link
      width="element.7xl"
      height="element.5xl"
      position="relative"
      mr="xs"
      display="inline-block"
      borderRadius="xs"
      onClick={onClick}
      target="_blank"
      href="https://play.google.com/store/apps/details?id=com.showpass.android"
      className={className}
    >
      <CDNImage
        useServerlessResize={false}
        src={`images/logos/${locale || "en"}/google-play-store.png`}
        alt={t("Download on Google Play")}
        fill
        style={{ objectFit: "contain" }}
      />
    </Link>
  );
}

export type GooglePlayStoreLinkProps = GooglePlayStoreLinkSharedProps & {
  // Add any web specific props here.
};
